import { HsbcPortalComponent, HSBC_PORTAL_NAME } from "@hsbc/portal";
import premierDestinationQuickPicksStyles from "./hsbc-portal/components/PremierDestinationQuickPicks/styles.module.scss";

export const styleOverrides = {
  [HSBC_PORTAL_NAME]: {
    [HsbcPortalComponent.PremierDestinationQuickPicks]:
      premierDestinationQuickPicksStyles,
  },
};
